import {
  NeoPageWrapper,
  NeoCard,
  NeoLeftPanel,
  NeoRightPanel,
  SkeletonBlock,
  SkeletonCircle,
  SkeletonRow,
  SkeletonLineItemRow,
  SkeletonLineBody,
} from "../../skins/neo/NeoStyles";

/**
 * Full-page skeleton for hosted checkout surfaces (/p/ and /s/) while session
 * config, routing, or catalog data is still loading.
 */
const HostedCheckoutSkeleton = () => (
  <NeoPageWrapper aria-busy="true" aria-label="Loading checkout">
    <NeoCard>
      <NeoLeftPanel>
        <SkeletonRow $mb="18px">
          <SkeletonBlock $h="18px" $w="24px" />
          <SkeletonCircle $size="32px" style={{ borderRadius: "8px" }} />
          <SkeletonBlock $h="16px" $w="42%" />
        </SkeletonRow>

        <SkeletonBlock $h="13px" $w="55%" $mb="10px" />
        <SkeletonBlock $h="36px" $w="42%" $r="6px" $mb="10px" />
        <SkeletonBlock $h="12px" $w="80%" $mb="24px" />

        <SkeletonLineItemRow>
          <SkeletonCircle $size="32px" style={{ borderRadius: "4px" }} />
          <SkeletonLineBody>
            <SkeletonBlock $h="13px" $w="60%" />
            <SkeletonBlock $h="11px" $w="45%" />
          </SkeletonLineBody>
          <SkeletonBlock $h="13px" $w="14%" />
        </SkeletonLineItemRow>

        <SkeletonRow $mb="10px">
          <SkeletonBlock $h="13px" $w="26%" />
          <SkeletonBlock $h="13px" $w="18%" />
        </SkeletonRow>
        <SkeletonRow>
          <SkeletonBlock $h="15px" $w="38%" />
          <SkeletonBlock $h="15px" $w="22%" />
        </SkeletonRow>
      </NeoLeftPanel>

      <NeoRightPanel>
        <SkeletonBlock $h="14px" $w="48%" $mb="18px" />

        <SkeletonBlock $h="12px" $w="36%" $mb="12px" />
        <SkeletonRow $mb="12px">
          <SkeletonBlock $h="40px" $w="48%" $r="8px" />
          <SkeletonBlock $h="40px" $w="48%" $r="8px" />
        </SkeletonRow>
        <SkeletonBlock $h="40px" $w="100%" $r="8px" $mb="24px" />

        <SkeletonBlock $h="12px" $w="52%" $mb="12px" />
        <SkeletonBlock $h="52px" $w="100%" $r="8px" $mb="10px" />
        <SkeletonBlock $h="52px" $w="100%" $r="8px" $mb="24px" />

        <SkeletonBlock $h="14px" $w="72%" $mb="16px" />
        <SkeletonBlock $h="48px" $w="100%" $r="8px" />
      </NeoRightPanel>
    </NeoCard>
  </NeoPageWrapper>
);

export default HostedCheckoutSkeleton;
